<script>
export default {
    name: 'ResponsiveIframe',
    props: ['title', 'src', 'figcaptionSrOnly'],
};
</script>
<template>
    <figure class="text-center">
        <div class="embed-responsive embed-responsive--bordered embed-responsive-16by9">
            <iframe
                :title="title"
                class="embed-responsive-item"
                :src="src"
                style="border: 0;"
                allow="fullscreen"
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            >
            </iframe>
        </div>
        <figcaption class="mx-auto mt-2">
            <p v-html="title" :class="figcaptionSrOnly ? 'sr-only' : null"></p>
        </figcaption>
    </figure>
</template>
